import { ShopperAgentShortfallKind } from "@redotech/crdb-enums/shopper-ai/shopper-agent-shortfall-kind";
import * as z from "zod";

export const getShopperAgentShortfalls = {
  name: "getShopperAgentShortfalls" as const,
  input: z.object({
    start: z.date(),
    end: z.date(),
    /** Empty means every kind. */
    kinds: z.array(z.enum(ShopperAgentShortfallKind)),
    /** Only turns where this skill was not available. */
    unavailableSkill: z.string().nullable(),
    supervisorForced: z.boolean(),
    noKnowledge: z.boolean(),
    emptySearch: z.boolean(),
    /** Part of a store's name, or its whole team id. */
    store: z.string().nullable(),
    limit: z.number().int().min(1).max(200),
    offset: z.number().int().min(0),
  }),
  output: z.object({
    /** Newest first. */
    rows: z.array(
      z.object({
        id: z.string(),
        occurredAt: z.date(),
        teamId: z.string().nullable(),
        teamName: z.string().nullable(),
        channelThreadId: z.string(),
        kind: z.enum(ShopperAgentShortfallKind),
        /** The agent's own sentence. Null for a caught handoff. */
        reason: z.string().nullable(),
        shopperMessage: z.string().nullable(),
        availableSkills: z.array(z.string()).nullable(),
        loadedSkills: z.array(z.string()).nullable(),
        supervisorBlocked: z.boolean(),
        supervisorForced: z.boolean(),
        hasKnowledge: z.boolean().nullable(),
        knowledgeSearches: z.number().nullable(),
        emptyKnowledgeSearches: z.number().nullable(),
        model: z.string().nullable(),
        supportTicketId: z.string().nullable(),
      }),
    ),
    /** Every row the filter matches, across pages. */
    total: z.number(),
  }),
};
